var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow","transform":"translate(1 1.414)"},[React.createElement("path",{"id":"Path_1211","data-name":"Path 1211","d":"M2628.173-1871.707l10.02,10.02-10.02,10.02","transform":"translate(-2615.5 1871.707)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_214","data-name":"Line 214","x1":"21","transform":"translate(0 10.207)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"2","key":1})]));
}

Arrow.defaultProps = {"width":"24.693","height":"22.868","viewBox":"0 0 24.693 22.868"};

module.exports = Arrow;

Arrow.default = Arrow;
